import { Component, OnInit } from '@angular/core';
import { CalendarService } from '../services/calendar.service';
import { getISOWeek, getISOWeekYear } from 'date-fns';
import { Router } from '@angular/router';
@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.less']
})
export class CalendarComponent implements OnInit {
  isCollapsed = false;
  getFullYear: number = new Date().getFullYear();
  loading = true;
  perPage = 1;
  page = 1;
  total:number;
  calendar:any=[];
  date = null;
  btnDisable:boolean = false;
  isSearch = false;
  filteredArr:any;
  week = getISOWeek(new Date());;
  year = getISOWeekYear(new Date());
  isSchedule = false;
  isLogin: boolean;

  getWeek(result: Date): void {
    this.isSearch = false;
    this.week = getISOWeek(result);
    this.year =  getISOWeekYear(result);
    this.getCalendar();    
  }

  panelChange(change: { date: Date; mode: string }): void {
    console.log(change.date, change.mode);
  }
  constructor(
    private calendarService: CalendarService,
    private readonly router: Router,
  ) {
    if (typeof localStorage !== 'undefined') {
      const currentUserJSON = localStorage.getItem("currentUser");
      if (currentUserJSON) {
        this.isLogin = true;
      } else {
        this.isLogin = false;
      }
    }

  }

  ngOnInit() {
    this.getCalendar();
  }

  getCalendar(){
    const queryValue = [(this.week)? 'title=tuần '+this.week : '', (this.year)?'year='+this.year: '']; 
    this.filteredArr = queryValue.filter((e) => { return e != ""; }).join('&');
    this.calendarService.searchCalendar(this.perPage, this.page, this.filteredArr).subscribe((res:any)=>{
      this.loading = false;
      this.total = res.data.total;
      this.calendar = res.data.docs;
      this.isSearch = true;
    });    
  }

  goBack(){
    this.week = this.week - 1;
    const queryValue = [(this.week)? 'title=tuần '+this.week : '', (this.year)?'year='+this.year: '']; 
    this.filteredArr = queryValue.filter((e) => { return e != ""; }).join('&');
    this.calendarService.searchCalendar(this.perPage, this.page, this.filteredArr).subscribe((res:any)=>{
      this.loading = false;
      this.total = res.data.total;
      this.calendar = res.data.docs;
      this.isSearch = true;
    });
  }

  goForward(){
    this.week = this.week + 1;
    const queryValue = [(this.week)? 'title=tuần '+this.week : '', (this.year)?'year='+this.year: '']; 
    this.filteredArr = queryValue.filter((e) => { return e != ""; }).join('&');
    this.calendarService.searchCalendar(this.perPage, this.page, this.filteredArr).subscribe((res:any)=>{
      this.loading = false;
      this.total = res.data.total;
      this.calendar = res.data.docs;
      this.isSearch = true;
    });
  }
  
}
